import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IInterviewReportData } from "../../interfaces/analytics";

const useGetInterviewReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IInterviewReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/interview-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['interview-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetInterviewReport;